<template>
    <div style="background: #f9f9f9">
        <!--    <img src="./model.svg" alt="" style="width: 100%;">-->
        <div class="softMarketTop">
            <div class="softMarketTopSearch">
                <div class="logoTitle">
                    <div class="logoTitle1">
                        3D商城
                        <p
                                style="
                font-size: 12px;
                color: rgb(219, 219, 219);
                text-transform: uppercase;
              "
                        >
                            3D MALL
                        </p>
                    </div>
                    <div class="logoTitle2">全部商品</div>
                </div>
                <div class="searchContainer">
                    <div class="flex searchContainerone">
                        <el-input
                                placeholder="请输入内容"
                                v-model="searchValue"
                                class="input-with-select"
                                @keyup.native.enter="getShopList"
                        >
                            <el-button slot="append" @click="getShopList">
                                <i class="el-icon-search" style="font-size: 24px"></i>
                            </el-button>
                        </el-input>
                        <button plain class="searchContainerButton" @click="toServiceAuthentication">商家入驻</button>
                    </div>

                    <ul>
                        <li class="textLi" @click="searchByKeyword(items)" v-for="(items, index) in keywords">{{ items }}</li>
                    </ul>
                </div>
                <div class="shoppingCar" v-if="isShow">
                    <el-badge :value="goodsNum" class="item" style="margin-top:7px">
                        <el-button size="small" icon="el-icon-shopping-cart-full" @click="$router.push('/shopCar')">我的购物车</el-button>
                    </el-badge>
                </div>
            </div>
        </div>
        <div class="shopTitlenap">
            <p>当前位置：</p>
            <el-breadcrumb separator=">">
                <el-breadcrumb-item :to="{ path: '/mall' }">3D商城</el-breadcrumb-item>
                <el-breadcrumb-item v-if="categoryName!=''" >{{categoryName}}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="secondCategoryName!=''" >{{secondCategoryName}}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="thirdCategoryName!=''" >{{thirdCategoryName}}</el-breadcrumb-item>
            </el-breadcrumb>
            <!-- <span>首页</span>
             <i class="el-icon-arrow-right"></i>
             <span> 全部商品</span>
             <i class="el-icon-arrow-right" v-if="categoryName!=''"></i>
             <span v-if="categoryName!=''" style="color: #3a8ee6;"> {{ categoryName }}</span>
             <i class="el-icon-arrow-right" v-if="secondCategoryName!=''"></i>
             <span v-if="secondCategoryName!=''" style="color: #3a8ee6;"> {{ secondCategoryName }}</span>
             <i class="el-icon-arrow-right" v-if="thirdCategoryName!=''"></i>
             <span v-if="thirdCategoryName!=''" style="color: #3a8ee6;"> {{ thirdCategoryName }}</span> -->
        </div>

        <div class="print_screen">
            <div class="print_screen_box flex" style="position: relative">
                <p class="print_title">一级分类：</p>
                <div style="width: 100%">
                    <!-- 一级分类 -->
                    <div class="print_screen_boxP" style="margin-bottom: 6px;">
                        <p
                                v-for="(items, index) in firstList"
                                :key="index"
                                @click="changeScreen(index,items.code,items.uuid,items.name)"
                                :class="printScreenIndex == index ? 'screen_text' : ''"
                        >
                            {{ items.name }}
                        </p>
                    </div>
                    <!-- 二级分类 -->
                    <div v-show="classShow" style="display: flex;margin-left: -111px;">
                        <p class="print_title">二级分类：</p>
                        <div class="print_screen_boxP">
                            <p
                                    v-for="(items, index) in secondList"
                                    :key="index"
                                    :class="printScreenTwoIndex == index ? 'screen_text' : ''"
                                    @click="changeScreenTwo(index,items.code,items.uuid,items.name)"
                                    style="cursor: pointer"
                            >
                                {{ items.name }}
                            </p>
                        </div>
                    </div>

                    <!-- 三级分类 -->
                    <div class="flex" style="padding: 15px 15px 5px;background: rgb(241, 245, 254);color: #333;margin-left:-20px;display:flex;flex-wrap:wrap" v-show="classShow1">
                        <p
                                v-for="(items, index) in thirdList"
                                :key="index"
                                :class="printScreenThreeIndex == index ? 'materDetailsT' : ''"
                                @click="changeScreenThree(index,items.code,items.name)"
                                style="cursor: pointer"
                        >
                            {{ items.name }}
                        </p>
                    </div>
                </div>
            </div>
            <!-- 内容 -->

            <!-- 筛选 -->
            <div class="flex print_screen_box print_shai">
                <p class="print_title">筛选：</p>
                <p
                        :class="printNews2 == index ? 'print_newsPs' : 'print_newsP'"
                        v-for="(items, index) in printNewss2"
                        :key="index"
                        @click="search(items,index)"
                >
                    {{ items.name }}
                </p>
            </div>
        </div>
        <div class="print_news flex">
            <div class="flex print_news1">
                <p class="print_title">排序：</p>
                <p
                        style="cursor: pointer"
                        :class="printNews == 'createTime' ? 'print_sort' : ''"
                        @click="getPrintNews('createTime')"
                >
                    <!-- 默认 -->
                    最新
                    <i class="el-icon-bottom" v-if="getPrintNews3==1"></i>
                    <i class="el-icon-top" v-if="getPrintNews3==0"></i>
                </p>
                <p
                        style="cursor: pointer"
                        :class="printNews == index ? 'print_sort' : ''"
                        v-for="(items, index) in printNewss"
                        :key="index"
                        @click="getPrintNews(index)"
                >
                    {{ items.title }}
                    <!-- <i class="el-icon-arrow-down"></i> -->
                    <i class="el-icon-bottom" v-if="index==0&&getPrintNews2==1"></i>
                    <i class="el-icon-top" v-if="index==0&&getPrintNews2==0"></i>
                    <i class="el-icon-bottom" v-if="index==1&&getPrintNews1==1 "></i>
                    <i class="el-icon-top" v-if="index==1&&getPrintNews1==0"></i>
                </p>
                <p
                        style="cursor: pointer"
                        :class="printNews == 'price' ? 'print_sort' : ''"
                        @click="getPrintNews('price')"
                        class="flex priceIconbox"
                >
                    价格
                    <!-- <span class="priceIcon">
                        <i class="el-icon-arrow-up"></i>
                        <i class="el-icon-arrow-down"></i>
                    </span> -->
                    <i class="el-icon-bottom" v-if="getPrintNews4==0"></i>
                    <i class="el-icon-top" v-if="getPrintNews4==1"></i>
                </p>
            </div>
            <div class="print_input">
                <p>{{ total }}件商品</p>
            </div>
        </div>
        <div class="container">
            <section style="padding-bottom: 30px">
                <div class="dmessagesBottom" v-if="modelList.length!=0">
                    <div
                            class="dmessagesBottombox"
                            v-for="(items, index) in modelList"
                            :key="index"
                            @click="handGoodsDetails(items.uuid)"
                    >
                        <img :src="items.imgUrl" alt=""/>
                        <div class="sdmessagesbotMes">
                            <el-tooltip class="item" effect="dark" :content="items.name" placement="bottom">
                                <h4>{{ items.name }}</h4>
                            </el-tooltip>
                            <p>{{ items.shopName }}</p>
                            <span>¥{{ items.minPrice }}</span>
                        </div>
                    </div>
                    <div class="dmessagesBottombox2"></div>
                    <div class="dmessagesBottombox2"></div>
                    <div class="dmessagesBottombox2"></div>
                    <div class="dmessagesBottombox2"></div>
                    <div style="text-align: center; width: 100%">
                        <el-pagination
                                style="margin-right: -10px"
                                @current-change="handleCurrentChange"
                                @prev-click="handleCurrentChange"
                                @next-click="handleCurrentChange"
                                layout="total,prev, pager, next,jumper"
                                :current-page="current"
                                :page-size="pageSize"
                                :total="total">
                        </el-pagination>
                    </div>
                </div>
                <div style="text-align:center" v-if="showNoGoods">
                    <img src="../../assets/暂无搜索内容.jpg" alt="" style="width:200px">
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex";
    import { getDictionaryItem, getShopList,getShopCategoryList,getNewcurrent,designerByUserId,getShopCarNumber} from "../../utils/interface";
    export default {
        //   商品列表
        name: "shopGoodsList",
        metaInfo: {
            title: '3D打印人气商品推荐-3D商城-增材云— 创意出发，打印无限可能！/  增材云— 增材制造领域首个综合性工业互联网平台！', // set a title
            meta: [{                 // set meta
                name: 'keywords',
                content: '打印机 | 打印设备 | 打印机零件 | 打印进耗材 | 配件'
            },{                 // set meta
                name: 'description',
                content: '增材云3D商城汇聚产业链上下游商家资源，提供打印机、打印设备、打印配件、打印耗材等资源，为企业提供从产品展示到采购交易的一站式服务。'
            }],
        },
        data() {
            return {
                showNoGoods:false,
                getPrintNews1:1,
                getPrintNews2:1,
                getPrintNews3:1,
                getPrintNews4:1,
                searchValue:'',
                classShow1:false,
                setIn: null,
                imgHeight: "",
                imgHeightsetIn: null,
                groupCode: "model_banner",
                // groupCode: "SOLUTION_BANNER", // 类别
                bannerList: [],
                modelList: [],
                // 分类信息
                firstList: [],
                firstUuid:"",
                secondList:[],
                secondUuid:"",
                thirdList:[],
                thirdUuid:"",
                grade:1,
                type:"PLATFORM",
                parentUuid:"",
                printScreenIndex: 0,
                printScreenTwoIndex: 0,
                printScreenThreeIndex: 0,
                classShow: false,
                // 排序
                printNewss: [
                    {
                        title: "销量",
                    },
                    {
                        title: "人气",
                    },
                ],
                printNews: "createTime",
                // 筛选
                printNewss2: [
                    {
                        value: null,
                        name: "全部",
                    },
                    {
                        value: true,
                        name: "仅显示有货",
                    },
                ],
                printNews2: "0",
                isStock:null,
                // 分页查询条件
                current:1,
                pageSize:20,
                total:0,
                orderBy:"createTime_descend",
                userMessages:{},
                // 商家入驻信息
                identity:"",
                categoryUuid: "",
                secondCategoryUuid: "",
                thirdCategoryUuid: "",
                keywords:[],
                isShow:false,
                goodsNum:0,
                // 面包屑
                categoryName:"",
                secondCategoryName:"",
                thirdCategoryName:"",
            };
        },
        computed: {
            ...mapState({
                isLogin: "isLogin",
                isUsermessage:"isUsermessage"
            }),
        },
        created() {
            this.getShopCarNumber();
            this.categoryUuid = this.$route.params.uuid;
            this.secondCategoryUuid = this.$route.params.secondUuid;
            this.thirdCategoryUuid = this.$route.params.thirdUuid;
            getDictionaryItem({groupCode: 'shop_keyword'}).then((res)=>{
                if(res != null && res.length > 0){
                    res.forEach((item, index) => {
                        this.keywords.push(item.name);
                    });
                }
            });
            // 如果不为空则查询两级数据
            this.getShopCategoryList1();
            if (this.$route.query.keywords != undefined) {
                this.searchValue = this.$route.query.keywords;
                this.getShopList();
            }
            if(!this.categoryUuid && !this.secondCategoryUuid && !this.thirdCategoryUuid){
                this.getShopList();
            }
            // 获取用户信息
            getNewcurrent().then((res) => {
                this.userMessages = res;
            })
                .catch((err) => {
                    console.log(err);
                });
        },
        methods: {
            getShopCarNumber(){
                if(this.isLogin){
                    this.isShow = true;
                    getShopCarNumber().then((res)=>{
                        if(res.success) {
                            this.goodsNum = res.data;
                        }
                    })
                }else{
                    this.isShow = false;
                }
            },
            ...mapMutations(["isLoginVuex"]),
            // 商家入驻
            toServiceAuthentication() {
                if(this.$store.state.isLogin) {
                    getNewcurrent().then((data) => {
                        designerByUserId(data.uuid).then((res)=>{
                            if (res != null && res !== "") {
                                this.$message({
                                    type: "error",
                                    message: "您已申请平台设计师，无法申请入驻店铺！",
                                });
                                return false;
                            }else {
                                this.identity = data.identity;
                                if (this.identity === 'ENTERPRISE') {
                                    this.$router.push({
                                        name: "shopServiceAuthentication",
                                    });
                                } else if (this.identity === 'PERSONAL' || this.identity === 'ANONYMOUS') {
                                    this.$confirm('请先进行企业资质认证!', '提示', {
                                        confirmButtonText: '去认证',
                                        cancelButtonText: '取消',
                                        type: 'warning'
                                    }).then(() => {
                                        window.sessionStorage.setItem("userServeId", "11");
                                        let routeData = this.$router.resolve({
                                            name: "userCenter",
                                            params: {
                                                userServeId: '11',
                                            },
                                        });
                                        window.open(routeData.href, "_target");
                                    });
                                }
                            }
                        });
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: "您需要先登录哦！",
                    });
                    this.$router.push("/login");
                    return false;
                }
            },
            getShopCategoryList1(){
                let params = {
                    parentUuid:this.parentUuid,
                    grade:this.grade,
                    type:this.type,
                }
                getShopCategoryList(params).then((res)=>{
                    this.firstList = res;
                    this.firstList.unshift({uuid:"",name:"全部"});
                    if(this.categoryUuid!=undefined){
                        this.firstList.map((item,index)=>{
                            if(this.categoryUuid===item.uuid){
                                this.classShow = true;
                                this.classShow1 = false;
                                this.firstUuid = item.code;
                                this.secondUuid = "";
                                this.thirdUuid = "";
                                this.categoryName = item.name;
                                this.secondCategoryName = "";
                                this.thirdCategoryName = "";
                                this.printScreenIndex = index;
                                this.printScreenTwoIndex = 0;
                                // this.changeScreen(index,item.code,item.uuid,item.name);
                                let params = {
                                    parentUuid:item.uuid,
                                    grade:2,
                                    type:this.type,
                                };
                                getShopCategoryList(params).then((res)=>{
                                    this.secondList = res;
                                    this.secondList.unshift({uuid:"",name:"全部"});
                                    if(this.secondCategoryUuid!=undefined){
                                        this.secondList.map((item,index)=> {
                                            if (this.secondCategoryUuid === item.uuid) {
                                                // this.changeScreenTwo(index,item.code,item.uuid,item.name);
                                                this.classShow1 = true;
                                                this.secondUuid = item.code;
                                                this.secondCategoryName = item.name;
                                                this.thirdCategoryName = "";
                                                this.printScreenThreeIndex = 0;
                                                this.printScreenTwoIndex = index;
                                                if(this.thirdCategoryUuid!=undefined){
                                                    let params = {
                                                        parentUuid:item.uuid,
                                                        grade:3,
                                                        type:this.type,
                                                    };
                                                    getShopCategoryList(params).then((res)=>{
                                                        this.thirdList = res;
                                                        this.thirdList.unshift({uuid:"",name:"全部"});
                                                        this.thirdList.map((item,index)=> {
                                                            if (this.thirdCategoryUuid === item.uuid) {
                                                                this.changeScreenThree(index,item.code,item.name);
                                                            }
                                                        })
                                                    });
                                                }else {
                                                    this.changeScreenTwo(index,item.code,item.uuid,item.name);
                                                }
                                            }
                                        });
                                    }else {
                                        this.changeScreen(index,item.code,item.uuid,item.name);
                                    }
                                });
                            }
                        });
                    }else {
                        this.getShopList();
                    }
                });
            },
            searchByKeyword(keyword){
                this.searchValue = keyword;
                this.getShopList();
            },
            getShopList() {
                let params = {
                    name: this.searchValue,
                    status:"SHELVE",
                    isStock:this.isStock,
                    current:this.current,
                    pageSize:this.pageSize,
                    firstCategoryUuid:this.firstUuid,
                    secondCategoryUuid:this.secondUuid,
                    storeTypeUuid:this.thirdUuid,
                    orderBy:this.orderBy,
                }
                getShopList(params).then((res)=>{
                    this.total = res.total;
                    this.modelList = res.list;
                    if(res.total < 1){
                        this.showNoGoods=true;
                    }else {
                        this.showNoGoods=false;
                    }
                });
            },
            handleCurrentChange(val){
                this.current = val;
				window.scrollTo(0,0);
                this.getShopList();
            },
            search(item,index){
                this.printNews2 = index;
                this.isStock = item.value;
                this.getShopList();
            },
            // 商品详情
            handGoodsDetails(uuid) {
                let routeData = this.$router.resolve({
                    name: "shopGoodDetails",
                    params: { uuid: uuid },
                });
                window.open(routeData.href, "_blank");
            },
            //查询二级分类
            changeScreen(index,code,uuid,name){
                this.firstUuid = "";
                this.secondUuid = "";
                this.thirdUuid = "";
                this.categoryName = name;
                this.secondCategoryName = "";
                this.thirdCategoryName = "";
                this.printScreenIndex = index;
                this.printScreenTwoIndex = 0;
                if(index==0){
                    this.classShow = false;
                    this.classShow1 = false;
                }else{
                    this.classShow = true;
                    this.classShow1 = false;
                    this.firstUuid = code;
                    this.secondList = [];
                    let params = {
                        parentUuid:uuid,
                        grade:2,
                        type:this.type,
                    };
                    getShopCategoryList(params).then((res)=>{
                        this.secondList = res;
                        this.secondList.unshift({uuid:"",name:"全部"});
                    });
                }
                this.getShopList();
            },
            // 查询三级分类
            changeScreenTwo(index,code,uuid,name){
                this.secondUuid = "";
                this.thirdUuid = "";
                this.secondCategoryName = name;
                this.thirdCategoryName = "";
                this.printScreenThreeIndex = 0;
                this.printScreenTwoIndex = index;
                if(index==0){
                    this.classShow1 = false;
                }else{
                    this.classShow1 = true;
                    this.secondUuid = code;
                    this.thirdList = [];
                    let params = {
                        parentUuid:uuid,
                        grade:3,
                        type:this.type,
                    };
                    getShopCategoryList(params).then((res)=>{
                        this.thirdList = res;
                        this.thirdList.unshift({uuid:"",name:"全部"});
                    });
                }
                this.getShopList();
            },
            changeScreenThree(index,uuid,name){
                this.thirdCategoryName = name;
                this.thirdUuid = "";
                this.printScreenThreeIndex = index;
                if(index==0){
                    // 全部不做操作
                }else{
                    this.thirdUuid = uuid;
                }
                this.getShopList();
            },
            getPrintNews(i) {
                this.printNews = i;
                if(i=='price'){
                    if(this.orderBy==='price_descend'){
                        this.orderBy = 'price_ascend';
                        this.getPrintNews4 = 1;
                    }else {
                        this.orderBy = "price_descend";
                        this.getPrintNews4 = 0;
                    }
                }else if(i===1){
                    if(this.getPrintNews1==0){
                        this.orderBy = 'volume_descend';
                        this.getPrintNews1 = 1;
                    }else{
                        this.orderBy = 'volume_ascend';
                        this.getPrintNews1 = 0;
                    }
                    // console.log(1)人气
                }else if(i=='createTime'){
                    // this.orderBy = "createTime_descend";
                    if(this.getPrintNews3==0){
                        this.orderBy = "createTime_descend";
                        this.getPrintNews3 = 1;
                    }else{
                        this.orderBy = "createTime_ascend";
                        this.getPrintNews3 = 0;
                    }
                }else{
                    if(this.getPrintNews2==0){
                        this.orderBy = "soldAmount_descend";
                        this.getPrintNews2 = 1
                    }else{
                        this.orderBy = "soldAmount_ascend";
                        this.getPrintNews2 = 0;
                    }
                    //  console.log("3")销量
                }
                this.getShopList();
            },
        }
    }
</script>

<style scoped lang="less">
    .blue {
        color: #157efb;

    }

    .container {
        width: 1200px;
        margin: 0 auto;

        /deep/ .vue-waterfall {
            overflow-y: unset;
            overflow-x: unset;
        }
    }

    .shopTitlenap {
        width: 1200px;
        margin: 20px auto 26px;
        font-size: 14px;
        align-items: center;
        display: flex;

        p {
            color: #808080;
        }

        span:nth-last-of-type(1) {
            color: #157efb;
        }

        i {
            margin: 0 2px;
        }

        .blue {
            color: #157efb;
        }
    }

    .print_screen {
        background: #f9f9f9;

        .print_screen_box {
            background: #fff;
            width: 1200px;
            margin: 0 auto;
            // flex-wrap: wrap;
            padding: 20px 15px 10px 20px;
            box-sizing: border-box;

            .print_title {
                flex-shrink: 0;
                color: #808080;
                padding-right: 41px;
                padding-left: 0px;
            }

            .print_screen_boxP {
                display: flex;
                flex-wrap: wrap;
                margin-left: -29px;
                p {
                    cursor: pointer;
                }

                .screen_text {
                    color: #157efb;
                    background: #157efb;
                    border-radius: 5px;
                    margin-bottom: 10px;
                    color: #fff;
                    padding: 3px 15px;
                    font-size: 14px;
                    cursor: pointer;
                }
            }

            .screen_text {
                color: #157efb;
                cursor: pointer;
                background: #157efb;
                border-radius: 5px;
                margin-bottom: 10px;
                color: #fff;
                padding: 3px 15px;
                font-size: 14px;
            }

            p {
                margin-bottom: 10px;
                margin-right: 0px;
                padding: 3px 14px;
                font-size: 14px;
            }

            .materDetailsT {
                // background: #157efb;
                color: #157efb;
                border-radius: 5px;
                padding: 3px 15px;
                margin-bottom: 10px;
            }
        }

        .print_screen_box:nth-last-child(1) {
            border-top: 1px solid #efefef;
        }
    }

    .print_news {
        width: 1200px;
        margin: 0 auto;
        background-color: #f7f7f7;
        justify-content: space-between;

        p {
            font-size: 14px;
            padding: 3px 15px;
            margin-right: 10px;
            border-radius: 3px;
            padding: 3px 9px;
        }

        .print_news1 {
            padding: 15px 20px;
            flex-shrink: 0;
            color: #333;

            .print_title {
                flex-shrink: 0;
                color: #808080;
                padding-right: 41px;
                padding-left: 0px;
            }

            .priceIconbox {
                align-items: center;

                .priceIcon {
                    display: flex;
                    flex-direction: column;
                    margin-left: 2px;

                    i {
                        height: 10px;
                        font-size: 12px;
                    }
                }
            }
            .print_sort {
                background: #157efb;
                color: #fff;
            }
        }
    }

    .print_shai {
        font-size: 14px;

        p {
            background: #fff;
            padding: 3px 15px;
        }

        .print_newsP {
            margin-right: 30px;
            cursor: pointer;
            background: #fff;
            border-radius: 3px;
            padding: 3px 15px;
        }

        .print_newsPs {
            color: #fff;
            background: #157efb;
            border-radius: 5px;
            padding: 3px 15px;
        }
    }

    .print_sort {
        color: #1f7de9;
    }

    .print_input {
        width: 1200px;
        margin: 0 auto;
        text-align: right;

        position: relative;
        margin-bottom: 15px;
        margin-top: 15px;

        p {
            color: #1f7de9;
        }
    }

    .softMarketTop {
        width: 100%;
        // height: 110px;
        background: #fff;
        box-sizing: border-box;

        .softMarketTopSearch {
            width: 1200px;
            margin: 0 auto;
            height: 100%;
            display: flex;
            padding-top: 18px;
            // padding-bottom: 18px;
            box-sizing: border-box;

            .logoTitle {
                font-size: 18px;
                // line-height: 74px;
                color: #157efb;
                font-weight: bold;

                .logoTitle1 {
                    height: 40px;
                    color: #000;
                }

                .logoTitle2 {
                    background: #000;
                    height: 40px;
                    color: #fff;
                    line-height: 40px;
                    width: 246px;
                    padding-left: 20px;
                    box-sizing: border-box;
                    margin-top: 6px;
                    font-weight: 400;
                }
            }

            .searchContainer {
                // width: 690px;
                margin: 0 auto;
                padding: 0 15px;

                .searchContainerone {
                    .input-with-select {
                        flex-shrink: 0;
                    }

                    .searchContainerButton {
                        color: #157efb;
                        margin-left: 15px;
                        border: 1px solid #157efb;
                        width: 88px;
                        background: #fff;
                        font-size: 14px;
                        border-radius: 10px;
                    }
                }

                /deep/ .input-with-select .el-input__inner {
                    border: 2px solid #157efb;
                    border-top-left-radius: 10px;
                    border-bottom-left-radius: 10px;
                    background: #fdfdfd;
                    height: 40px;
                    line-height: 40px;
                }

                /deep/ .el-input-group {
                    height: 40px;
                    width: 618px;
                }

                /deep/ .input-with-select .el-input-group__append {
                    background: #157efb;
                    color: #fff;
                    border: 1px solid #157efb;
                    border-left: none;
                    border-radius: 0px 10px 10px 0px;
                    width: 80px;
                    box-sizing: border-box;
                    text-align: center;
                }

                ul {
                    display: flex;
                    color: #c0c0c0;
                    padding-left: 3px;

                    li {
                        font-size: 12px;
                        padding: 8px 20px 0 0;

                        &.textLi {
                            padding: 10px 20px 0 0;
                            cursor: pointer;

                            &:hover {
                                color: #157efb;
                            }
                        }
                    }
                }
            }
        }
    }

    .dmessagesBottom {
        display: flex;
        justify-content: space-between;
        background: #fff;
        padding: 34px 20px;
        flex-wrap: wrap;

        .dmessagesBottombox {
            width: 216px;
            // margin-bottom: 25px;
            margin-bottom: 19px;

            img {
                width: 100%;
                height: 138px;
                background: #efefef;
                display: block;
                cursor: pointer;
            }

            .sdmessagesbotMes {
                cursor: pointer;
                width: 100%;
                height: 80px;
                color: #0f1826;
                text-align: center;
                background: #f5f5f5;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                h4 {
                    font-size: 14px;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    width: 85%;
                    font-weight: 600;
                }

                p {
                    font-size: 12px;
                    margin: 2px 0;
                    font-weight: 400;
                }

                span {
                    font-size: 12px;
                    font-weight: bold;
                    color: #ff0000;
                }
            }
        }
        .dmessagesBottombox:hover {
            box-shadow: 0 0 10px 4px #c7c7c77e;
            .sdmessagesbotMes {
                background: #157efb;
                color: #fff;
                span {
                    color: #fff;
                }
            }
            p {
                color: #fff;
            }
        }

        .dmessagesBottombox2 {
            width: 216px;
            height: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/threeShop/shopGoodsList.vue